import { Component, Inject, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ImageCaptureModalComponent } from 'src/app/extensions/components/image-capture-modal/image-capture-modal.component';
import { UploadAPIService } from 'src/app/extensions/services/api/upload-api.service';
import { NotificationService } from '../../../../core/services/notification.service';
import { TranslateService } from '@ngx-translate/core';
import { FileEvents } from 'src/app/extensions/services/api/events';
import { convertFileSize } from 'src/app/extensions/utilities';
import { FILE_UPLOAD_ERROR_CODE } from 'src/app/extensions/constants/commonConstants';
import { ENV_CONFIG } from 'src/app/core/injection.token';

@Component({
  selector: 'asset-document-request-uploader',
  templateUrl: './uploader.component.html',
  styleUrls: ['./uploader.component.scss'],
  standalone: false,
})
export class AssetDocumentUploaderComponent {
  @Input() assetDocumentRequest: app.models.RequestXDocument[];
  @Input() deleteFileHandler: any;
  @Input() uploadFilesHandler: any;

  UPLOAD_ALLOWED_EXTENSIONS = [
    ...this._envConfig.ALLOWED_FILE_EXTENSIONS.DOCUMENTS,
    ...this._envConfig.ALLOWED_FILE_EXTENSIONS.IMAGES,
  ].map(extension => `.${extension}`);

  acceptExtensions = this.UPLOAD_ALLOWED_EXTENSIONS.join(',');

  constructor(
    private _uploadAPIService: UploadAPIService,
    private _ngbModal: NgbModal,
    private _notificationService: NotificationService,
    private _translateService: TranslateService,
    @Inject(ENV_CONFIG) private _envConfig: env.EnvConfigurationData
  ) {}

  openImageCaptureModal() {
    let modal = this._ngbModal.open(ImageCaptureModalComponent, { centered: true, backdrop: 'static' });

    modal.result.then(result => {
      if (result) {
        var formData = new FormData();
        formData.append('Files', result, result.name);
        this._uploadAPIService.uploadFile(formData).subscribe(result => {
          if (result.events.some(x => x.eventType == FileEvents.PortalFilePostFailed)) {
            const failedEvents = result.events.filter(x => x.eventType == FileEvents.PortalFilePostFailed);
            const eventCodes = failedEvents.map(e => e.eventBody.eventCode);

            let notification = '';

            if (eventCodes.includes(FILE_UPLOAD_ERROR_CODE.VIRUS)) {
              notification =
                failedEvents.length > 1 ? 'common.uploadedFilesContainsVirus' : 'common.uploadedFileContainsVirus';
            } else if (eventCodes.includes(FILE_UPLOAD_ERROR_CODE.INVALID_FILE_TYPE)) {
              notification =
                failedEvents.length > 1 ? 'common.uploadedFilesInvalidType' : 'common.uploadedFileInvalidType';
            }

            if (notification) {
              this._notificationService.showWarning(
                this._translateService.instant(notification),
                this._translateService.instant('common.warning')
              );
            }
            return;
          }
          const eventBodies = result.events.map(event => {
            const eventBody = event.eventBody;
            eventBody.convertedDocumentSize = convertFileSize(eventBody.documentSize);
            return eventBody;
          });
          this.assetDocumentRequest.push(...eventBodies);
        });
      }
    });
  }
}
